import type { CoreApiClient } from "../client";
import { createModuleMutations } from "../mutations/module.mutations";
import { createModuleQueries } from "../queries/module.queries";

export const createModuleRepository = (api: CoreApiClient) => ({
  ...createModuleQueries(api),
  ...createModuleMutations(api),
});
